// extracted by mini-css-extract-plugin
module.exports = {"block":"totalsStyles_block__2h-21","blockItem":"totalsStyles_blockItem__jXugq"};